import { RecordWithImageFields } from '@akin-home/images';
import { postImageToCloud } from './postImageToCloud';

export * from './fetchFileBlob';
export * from './postImageBlobToS3';
export * from './postImageToCloud';


export const hasImage = (item: RecordWithImageFields): boolean =>
  !!(item.image || item.profilePicture || item.imageUrl || item.imageUpload);

export const handleImageFieldsOnPost = async <T extends RecordWithImageFields>(
  item: T,
  options?: { habitatID?: string; readGroups?: string[] }
): Promise<T> => {
  const image = item.imageUpload
    ? await postImageToCloud({
        file: item.imageUpload,
        ...options,
      })
    : item.image;

  return {
    ...item,

    /** Clear the Image Upload */
    imageUpload: undefined,

    /** If an image is being uploaded, post it to the cloud and store in image attribute of returned item */
    image,
  };
};
